import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

export interface SkinProfile {
  id: string;
  display_name: string | null;
  username: string | null;
  skin_type: string | null;
  skin_concerns: string[];
  age_range: string | null;
  budget: string | null;
  allergies: string | null;
  lifestyle: string[];
  quiz_completed_at: string | null;
  address_style: "feminine" | "masculine" | "neutral" | null;
}

export const useProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<SkinProfile | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setProfile(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data } = await supabase
      .from("profiles")
      .select(
        "id, display_name, username, skin_type, skin_concerns, age_range, budget, allergies, lifestyle, quiz_completed_at, address_style",
      )
      .eq("id", user.id)
      .maybeSingle();
    setProfile((data as SkinProfile) ?? null);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { profile, loading, refresh };
};